import { areObjectIdsEqual } from 'helpers/idComparison';

/** Who the logs and error reports belong to. */
export interface CurrentUserIdentity {
  id: string;
  email: string;
}

const UNKNOWN = 'unknown';

export const unknownUserIdentity: CurrentUserIdentity = { id: UNKNOWN, email: UNKNOWN };

export function isKnownValue(value: string | undefined): value is string {
  return Boolean(value) && value !== UNKNOWN;
}

export function areIdentitiesEqual(first: CurrentUserIdentity, second: CurrentUserIdentity): boolean {
  return areObjectIdsEqual(first.id, second.id) && first.email === second.email;
}
